/**
 * Procedure Categories and Procedures for Diploma in Psychiatry (DPM) students
 * Extracted with strict evidence from official NMC PDF
 */
export const PSYCHIATRY_PROCEDURES = {
  "Somatic & Neuromodulation Interventions": [
    "Modified Electroconvulsive Therapy (ECT)",
    "Non-Invasive Neuromodulation (rTMS)",
  ],
  "Psychotherapy & Psychological Interventions": [
    "Supportive Psychotherapy",
    "Psychoeducation & Crisis Intervention",
    "Behaviour Therapy",
    "Family Therapy",
    "Interpersonal Therapy",
    "Cognitive Behaviour Therapy (CBT)",
    "First-Level Psychological Intervention for Sexual Abuse / Assault / Domestic Violence",
    "Genetic Counselling",
    "Clinical IQ Assessment & Psychometric Testing",
  ],
};

export const PSYCHIATRY_CATEGORIES = Object.keys(PSYCHIATRY_PROCEDURES);

export const isDiplomaInPsychiatryDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (d.includes("dpm") ||
    d.includes("psychiatry") ||
    d.includes("psychological medicine")) &&
    !d.includes("geriatric")
  );
};
